import { HttpsCallableOptions, HttpsCallableResult } from "firebase/functions";

import {
  StartTaskFunctionRequestType,
  StartTaskFunctionResultType,
} from "./task";

export enum FunctionsEnum {
  StartTask = "startTask",
}

export type FunctionOptionsType = {
  [FunctionsEnum.StartTask]: {
    body: StartTaskFunctionRequestType;
  };
} & Record<FunctionsEnum, HttpsCallableOptions>;

export type FunctionReturnType = {
  [FunctionsEnum.StartTask]: HttpsCallableResult<StartTaskFunctionResultType>;
};
